(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name itecAdministracio.api.persona.factory:PersonaFactory
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.api.usuari')
    .factory('UsuariFactory', UsuariFactory);

  function UsuariFactory(AdmConstant, DataFactory) {
    var api = AdmConstant.SERVER_PATH_ADMINISTRACIO + 'usuaris';
    
    var UsuariBase = {
        
      getAll: function(form){
        var url = api;
        return DataFactory.getWithParams(url, form);
      },

      get: function(id){
        var url = api + '/' + id + '/edit';
        return DataFactory.get(url);
      },

      add: function(obj){
        return DataFactory.add(api,obj);
      },

      update: function(id, obj){
        var url = api + '/' + id;
        return DataFactory.update(url,obj);
      },

      delete: function(id){
        var url = api;
        return DataFactory.delete(url, id);
      },
      avisconfirmar:function(id){
        var url = api + '/' + id + '/avisconfirmar';
        return DataFactory.add(url, {});
      },
      avisregistre:function(id){
        var url = api + '/' + id + '/avisregistre';
        return DataFactory.add(url,{});
      },
       getview: function(id){
        var url = api + '/' + id + '/view';
        return DataFactory.get(url);
      },
       renew: function(id, idproducte,tipusclient,versio){
        var url = api + '/' + id + '/renewdemo' + '/' + idproducte + '/' + tipusclient + '/' + versio ;
        return DataFactory.add(url,{});
      },
       unlock: function(id){
        var url = api + '/' + id + '/unlock';
        return DataFactory.add(url,{});
      }
    };
    return UsuariBase;
  }
}());
